<template>
    <div class="wrapper" ref="root">
        <!-- <scroller alwaysScrollableVertical="true" show-scrollbar="false" :class="['scroller',isiPhoneX ? 'marginBottom':'']"> -->
            <div class="body">
                 <div class="top_div">
                    <span class="top_text">开具电子发票</span>
                    <span class="top_text1">电子发票与纸质发票具有同等法律效力，可支持报销入账</span>
                    <!-- <span class="top_text2">* 暂不支持开具增值税专用发票，如需开具请联系项目运营人员</span> -->
                </div>
                <div class="selction_div">
                    <span class="selction_text">发票详情</span>
                </div>


                <!-- <div class="cell_div">
                        <span class="cell_title1">发票类型</span>
                        <span class="cell_title_type">{{ invoiceTypeName }}</span>
                    </div>
                <div class="Edit_line">
                    <div class="Edit_lineleft"></div>
                    <div class="Edit_lineright"></div>
                </div> -->
                <div class="module">
                    
                     <inpBox
                            title="发票类型"
                            inpBoxType="select"
                            :border="border"
                            @select="selectmarket()"
                            :selectValue="invoiceTypeName"
                    ></inpBox>
                </div>
             
                <div class="cell_div">
                    <span class="cell_title1">抬头类型</span>
                    <div v-if="isShowTax==false" class="cell_iconDiv1" @click="selectisShowTax(true)"></div>
                    <img v-else class="cell_left_iconimage"  @click="selectisShowTax(true)" :src="selectIcon" />
                    <span class="cell_title2" @click="selectisShowTax(true)">企业单位</span>
                    <div  v-if="isShowTax" class="cell_iconDiv2" @click="selectisShowTax(false)"></div>
                    <img v-else class="cell_right_iconimage"  @click="selectisShowTax(false)" :src="selectIcon"  />
                    <span class="cell_title3" @click="selectisShowTax(false)">个人</span>
                </div>
                <div class="cell_div">
                    <span class="cell_title1">发票抬头</span>
                    <!--  @change="onchange"
                            @input="oninput"
                            @focus="onfocus"
                            @blur="onblur" -->
                    <input  ref="textField"
                            :class="[isToolong()?'cellItem_inp1':'cellItem_inp']"
                            type="text" placeholder="填写发票抬头"
                            maxlength="30"
                            v-model="riseString"
                            v-on:input="specifiName($event)"

                            >
                    <!-- <div v-if="isShowClosesearch" class="closeIcon_div" @click="clearsesearch(0)">
                        <div  class="closeIcon_iconbg">
                            <span class="closeIcon_iconX"  @click="clearsesearch(0)">x</span>
                        </div>
                    </div> -->
                </div>
                <div class="Edit_line">
                    <div class="Edit_lineleft"></div>
                    <div class="Edit_lineright"></div>
                </div>
                <div  v-if="isShowTax" class="cell_div">
                    <span class="cell_title1">税号</span>
                    <!-- @focus="onfocusTax" @blur="onblurTax" -->
                    <input ref="textField1" class="cellItem_inp" type="text" placeholder="填写纳税人识别号"
                      maxlength="20" v-model="taxString">
                </div>
                <div v-if="isShowTax" class="Edit_line">
                    <div class="Edit_lineleft"></div>
                    <div class="Edit_lineright"></div>
                </div>
                <template v-if="invoiceType==3 || invoiceType==6">
                    <div class="cell_div" >
                        <span class="cell_title1">开户银行</span>
                        <input ref="textField21"
                                class="cellItem_inp" type="text" placeholder="开户银行" maxlength="25" v-model="bankName"
                        >
                    </div>
                    <div class="Edit_line"  >
                        <div class="Edit_lineleft"></div>
                        <div class="Edit_lineright"></div>
                    </div>
                    <div class="cell_div" >
                        <span class="cell_title1">银行账号</span>
                        <input ref="textField22"
                                class="cellItem_inp" type="text" placeholder="银行账号" maxlength="25" v-model="bankNumber"
                        >
                    </div>
                    <div class="Edit_line"  >
                        <div class="Edit_lineleft"></div>
                        <div class="Edit_lineright"></div>
                    </div>
                    <div class="cell_div" >
                        <span class="cell_title1">联系电话</span>
                        <input ref="textField23"
                                class="cellItem_inp" type="text" placeholder="联系电话" maxlength="20" v-model="companyTel"
                        >
                    </div>
                    <div class="Edit_line"  >
                        <div class="Edit_lineleft"></div>
                        <div class="Edit_lineright"></div>
                    </div>
                    <div class="cell_div" >
                        <span class="cell_title1">开票地址</span>
                        <input ref="textField24"
                                class="cellItem_inp" type="text" placeholder="开票地址" maxlength="40" v-model="companyAddress"
                        >
                    </div>
                    <div class="Edit_line" >
                        <div class="Edit_lineleft"></div>
                        <div class="Edit_lineright"></div>
                    </div>
                </template>
                <!--  -->
                <!-- <template v-if="invoiceType ==3 || invoiceType==6" >
                    <div class="cell_div">
                        <span class="cell_title1">开户行</span>
                        <input ref="textField1" class="cellItem_inp" type="text" placeholder="填写开户行"
                        maxlength="30" v-model="bankName">
                    </div>
                    <div  class="Edit_line">
                        <div class="Edit_lineleft"></div>
                        <div class="Edit_lineright"></div>
                    </div>
                    <div class="cell_div">
                        <span class="cell_title1">银行账号</span>
                        <input ref="textField1" class="cellItem_inp" type="text" placeholder="银行账号"
                        maxlength="30" v-model="bankNumber">
                    </div>
                    <div  class="Edit_line">
                        <div class="Edit_lineleft"></div>
                        <div class="Edit_lineright"></div>
                    </div>
                    <div class="cell_div">
                        <span class="cell_title1">联系电话</span>
                        <input ref="textField1" class="cellItem_inp" type="text" placeholder="银行账号"
                        maxlength="30" v-model="bankNumber">
                    </div>
                    <div  class="Edit_line">
                        <div class="Edit_lineleft"></div>
                        <div class="Edit_lineright"></div>
                    </div>
                </template> -->

                <div v-if="isShowTax&&resultList.length>0" class="Edit_list_div">
                    <scroll class="Edit_list">
                        <div class="cell" v-for="(v,i) in resultList"
                            append="tree"
                            :index="i"
                            :key="i"   :ref="'cell'+i">
                            <div class="Edit_list_cell_div" @click="cellselect(i)">
                                <span class="Edit_list_cell_titel1">{{v.enterpriseName}}</span>
                                <span class="Edit_list_cell_titel2">{{v.creditNo}}</span>
                                <div class="Edit_list_cell_line"></div>
                            </div>
                        </div>
                    </scroll>
                    <div class="Edit_list_buttonView">
                        <span class="Edit_list_buttonView_title" @click="closeList">关闭</span>
                    </div>
                </div>

                <!-- <div class="selction_div">
                    <span class="selction_text">接收方式</span>
                </div>   @focus="onfocusEmail" @blur="onblurEmail"  -->
                <div class="cell_div">
                    <span class="cell_title1">电子邮件</span>
                    <input ref="textField2"
                            class="cellItem_inp" type="text" placeholder="用于向您发送电子发票" maxlength="25" v-model="emailString"
                    >
                </div>
                <div class="Edit_line">
                    <div class="Edit_lineleft"></div>
                    <div class="Edit_lineright"></div>
                </div>
                <div class="cell_div">
                    <span class="cell_title1">发票内容</span>
                    <span class="cell_title_type">{{title}}</span>
                </div>
                <div class="cell_div">
                    <span class="cell_title1">发票金额</span>
                    <span  class="cell_title_price">{{allAmount+"元"}}</span>
                </div>


            </div>
        <!-- </scroller> -->
        <div class="footer" v-if="!isBottomShow">
            <div :class="['pdiv' ,validateparam()?'canclick':'']" @click="buttonAction">提交</div>
        </div>
        <div class="popupBg" v-if="isBottomShow" >
            <div class="popup_bg_div">
                <div class="popup_top_div">
                    <div class="popup_top_leftdiv"></div>
                    <span class="popup_top_title">开具电子发票</span>
                    <div class="popup_top_leftdiv">
                        <img class="popup_top_iconimage"  :src="closeIcon"  @click="popupOverlayBottomClick"/>
                    </div>
                </div>
                <div style="width: 750px;height:26px"></div>
                <div class="popup_cell_div">
                    <span class="popu_cell_left_text">发票类型</span>
                    <span class="popu_cell_right_text">{{invoiceTypeName}}</span>
                </div>
                <div class="popup_cell_div">
                    <span class="popu_cell_left_text">发票抬头</span>
                    <span class="popu_cell_right_text">{{riseString}}</span>
                </div>
                <div  v-if="isShowTax" class="popup_cell_div">
                    <span class="popu_cell_left_text">税号</span>
                    <span class="popu_cell_right_text">{{taxString}}</span>
                </div>
                <div class="popup_cell_div">
                    <span class="popu_cell_left_text">电子邮件</span>
                    <span class="popu_cell_right_text">{{emailString}}</span>
                </div>
                <div class="popup_cell_message_div">
                    <span class="popup_cell_message_text">请确认邮箱无误，电子发票将在系统开具后发送至您的邮箱，请注意查收</span>
                </div>
                <div  v-if="isShowTax==false" class="popup_cell_div">
                </div>
                <div style="width: 750px;height:6px"></div>
                <div class="button_view1">
                    <div  class="button_BG1"  @click="postData()" >
                        <span class="button_text1">确认提交</span>
                    </div>
                </div>
            </div>
        </div>
        <mt-popup v-model="popupVisible" position="bottom" class="mint-popup">
                <mt-picker
                class="picker"
                :slots="dataList"
                @change="onValuesChange"
                :visible-item-count="5"
                :show-toolbar="true"
                ref="picker"
                >
                <div class="picker_wrap">
                    <div class="picker_btn" @click="popupVisible=false">取消</div>
                    <div class="picker_btn2" @click="handleConfirm">确认</div>
                </div>
                </mt-picker>
        </mt-popup>

    </div>
</template>

<script>
    import {getReceiptList ,InvoicingaddReceipt ,ReceiptApiSearchByName} from '../../utils/api';
    import { mapState } from "vuex";
     import storage from '../../utils/storage';
     import inpBox from '../../components/inpBox';
    import util from '../../utils/util';
    import Scroll from "../../components/scroll";
    export default {
        name: "billfrom",
        components: {
             Scroll,
             inpBox,
        },
        computed: {
            ...mapState({
                    common: state => state.common
            })
        },
        data () {
            return {
                title: "租赁账单",
                orderNoList:"",
                riseString:"",
                taxString:"",
                emailString:"",
                searchVal:"",
                allAmount:0,
                LmarketId:'',
                invoiceType:4,//(1增值税普通发票；2增值税专用发票；4增值税电子普通发票)
                invoiceTypeName:'增值税电子普通发票',
                bankName:'', //开户银行：bankName
                bankNumber:'', // 银行账号：
                companyTel:'', //联系电话：
                companyAddress:'', //开票地址：
                popupVisible: false,
                invoiceTypeList:'',
                invoiceTypeValueList:[4,5,3,6], //1,2 4 5,
                invoiceTypeNameList :['增值税电子普通发票','增值税电子普通发票(全电）','增值税电子专用发票','增值税电子专用发票(全电）'], //'增值税普通发票','增值税专用发票', '增值税电子普通发票(全电）'
                dataList: [],
                selectType: "", //选择类型
                border: false,
                isShowTax:true,
                iszengzhi:true,
                isBottomShow:false,
                isShowTaxView:false,
                isRiseTooLong:false,
                isShowClosesearch:false,
                isShowClosetax:false,
                isShowCloseemail:false,
                isTrue: true,
                resultList:[],
                closeIcon:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAAXNSR0IArs4c6QAAAt1JREFUWAntlz+LGkEYxnUvIY1HUCvFxsYulWgKIbGySGz9CFaJnHf5An6B/OM25EPYiiSehaQRAmJnIQFNo2AlrM1pdPM+xglzw+3tzI4hcMyA7q77zjM/n33nnZ1QyDTjgHHAOGAcMA7cZwdOVP5cLpd7nkqlnlSr1R+9Xs9V6SvGNhoNy3GcF6SXnM1mP8X7Xtdhrxvi7wT7zHXdTjgcfkTHS/q8GQwGGzFO5jqbzT4knbf0qZHO9Xa7LQ2Hw28yfS2ZIMTsdrtTwNIRlzU6f1csFh/gQqWhD/pSnxq0oGlZ1qmshnRKJJPJKYk/JuGn5AoGyq/X61gikejO5/P9v/AbFM5uNpv3FPf6oIEul/T5LKshDQzBQqFwtVwuY4Bl0HQezWQyV9Pp9E5oOHsLrJ1Op8+73e4vkMs0aWCIjUYjl6A7IjScvgsasKvVSnQWsPVms7mVAWUxSsBBoI8Ji/GVgVWgPWA/BXEW46JJl7U/4Te/K5XKyWQy+UC/8pPILpfLZ4hstVofhXuAPVNNA2ixpgUMEQ9ozHw01FlUFJxrw0JEGxgiHo8+xMNGIpE6rY7S1QC6t7VAOSwKoaSJ1QMxB2f31aDdbitVA3EMdi290rEO//t4FIeREovF4sYEg7tscaG6Hac63fFbXGTM0AbGpDvAvuJyFpPuO0Hzy3ic0uYrFh8ZMK8YLeBDhYCzPCzKWp0c/TIej+ME/XcZh9O60IGrhBcsVYNzVg08qodWeQvksEfttXlYPFLkLN4x8K4hOB1DVQmSHsrAsrAsB48NrQSsCvsvoKWB8fJNk2a/U+CqgU3nF/1+33cFg9N42afUiArpEVXZBKgsHCUaiH832Oesyr4Oschzct4mLVana3RdYk/D7ygNTPsuh9y8piM0sQm9YNXAbxD+PvqgLzSgBU3a2zl8zNHOsc3P5/NlbNF1RaFBWi+hqatl+hsHjAPGAeOAceD+OPAbfN8R5938cTkAAAAASUVORK5CYII=",
                selectIcon:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAABA9JREFUWAnNmDtoFFEUhv/Z3URT2IgptIgoBowaUStRREN8NKIikiIq2PnoDD5AC5NIio2aENLaBMFCVFKJSMKKL4I2QoQIYrTSImIhgiZmd/z/uTPO7Li7Mxt3ZQ/cnde553z3v4+ZuxbKtQG7AfNoQQ67YKMdFjYwRKMbZob33vDeOBJ4jBSm0GX9KCeFFdu5325msk5kcYjJWlgW8Rp/igIpmldymCX0FJIY5b3buGC9k0uURQOl7RVMeo5BjzP4MiaBUwRTyhQ54ZYsvjDGLca4jovWp6hqxZ+n7cMMdI3Sr6YyBqS4d/EnAkuyzGOaUOcJdb+Yc2GF7thJVr3MFl5mxXoHpliEcu4LCpijwn1sYh86LDUzz/4GMjD9bFGXAxLVNXnhYlwoo8CyGCDUhTCUxMw3KVMtGGVSA6WLcihXyPIVStuH+PwuKyWdiiHnil4qs+WgHeGYGvVi+0CD9nJO1OccN6scN8+jmkd1XQ4fuIBsx1nrs1L5XTbL0V/3H2GUXV2nnMrtmlFIi14OE5RwqbPGeE//x1GS2PhKabZq8TQKaQVOVQFmnslUSpkWWuUWA82C3k1zeEHCTRUbO5xJSTb1YDPwbQ4Y+6hUJcyMpddc8bYlnBclsLZiXUWYesIM7wHuHQYedABtTYQppZRUEgNf2gmq0kZ1FldkmguGo3JoL3B6i5MEdYRrqDPnRX+1NomBLAl2WltsGLXyF4sChM2D2Qec2uw/vPESePSe1yn/XsEzxSSLBnVrwQShWhZbfqAFOLaJKii4kdl4CYaRhkIwg6+A8+PsrUINCMV3GVoVujESiMrsXgOMckwIrH0lcOYh8EOK8TrldlNQmUEqc44wDgufR5ocLTRKoXgWCHpiI3BzP7CYs0MBhkPKpCcMjCNioF6cRFJohmRNJVWi1/g0cOUZ0LvDhO1cx9azVd85rU8GxoxgLmXcHi0HxvjOCGgyEohOau3VJ0aRbhfq6HoD5/0uGEYBBGRjMsGfjHPhRS12VAX2T89TKsUStn+CUTADlEnwQyPD5v+MDcWKvSEozaYFdZPXKsGIgSwprg9TfHW8ZevjvTpUmSaoFBVbUs+pPbaAMWPCmF/NjBwZyGLCp+0rpOt2Fr2gY6lzZz7TQRHMlC3lXfqZVvIs81+0esSmoLf5HtEnQHwTiKvWn2P82r6nciq3GGgGwWziRiKXdz9M5c40z4ERbyPpa7KI+69f/JxMVi5XZCTlUk7lds0H0jetxZ2Azd70usLzqsbRjD3l6vK+p5XGB9KVvv5t9DoqVRNKsaWOcgV2HELIB9Id7Si1iVOFakB5MGaj2KeUQSucsqa20kHcmvmzIR+qhv6OCYLVzB9WQSida9s0i3Uc8Ds5Syr+l95voRJJrVBidEgAAAAASUVORK5CYII=",
            }
        },
        //  [{"id":16773,"typeId":13,"flag":false,"text":"增值税普通发票","value":"c","code":"1"},
        // {"id":16774,"typeId":13,"flag":false,"text":"增值税专用发票","value":"s","code":"2"},
        // {"id":16775,"typeId":13,"flag":false,"text":"增值税电子专用发票","value":"se","code":"3"},
        // {"id":16776,"typeId":13,"flag":false,"text":"增值税电子普票发票","value":"ce","code":"4"},
        // {"id":34331,"typeId":13,"flag":false,"text":"增值税电子普通发票(全电）","value":"ce","code":"5"},
        // {"id":34332,"typeId":13,"flag":false,"text":"增值税电子专用发票(全电）","value":"se","code":"6"}]

        created() {
            this.isBottomShow=false;
            let query = this.$route.query;
            this.viewType = query.viewType;
            this.LmarketId =this.common.marketInfo.id
             console.log(JSON.stringify(this.common.marketInfo))
            //  this.common.marketInfo.invoiceType =4
            if(this.common.marketInfo.invoiceType){ //默认类型
                this.invoiceType = Number(this.common.marketInfo.invoiceType)  
                if( this.invoiceType ==3){
                    this.invoiceTypeName ='增值税电子专用发票'
                }else if(this.invoiceType ==4){
                    this.invoiceTypeName ='增值税电子普通发票'
                }else if(this.invoiceType ==5){
                    this.invoiceTypeName  ='增值税电子普通发票(全电）'
                }else if(this.invoiceType ==6){
                    this.invoiceTypeName ='增值税电子专用发票(全电）'
                }
              
            }
            if(this.common.marketInfo.allowInvoiceType){ // 可开票类型
                var allowInvoiceTypeList = this.common.marketInfo.allowInvoiceType.split(',')
                var  invoiceTypeValueList =[]
                var invoiceTypeNameList =[]
                var index =0 ;
                for(var i=0;i<allowInvoiceTypeList.length;i++){
                   
                    if(allowInvoiceTypeList[i]=='3'){
                        invoiceTypeValueList.push(3)
                        invoiceTypeNameList.push('增值税电子专用发票')
                    }else if(allowInvoiceTypeList[i]=='4'){
                        invoiceTypeValueList.push(4)
                        invoiceTypeNameList.push('增值税电子普通发票')
                    }else if(allowInvoiceTypeList[i]=='5'){
                        invoiceTypeValueList.push(5)
                        invoiceTypeNameList.push('增值税电子普通发票(全电）')
                    }else if(allowInvoiceTypeList[i]=='6'){
                        invoiceTypeValueList.push(6)
                        invoiceTypeNameList.push('增值税电子专用发票(全电）')
                    }
                    if( allowInvoiceTypeList[i] == this.common.marketInfo.invoiceType ){
                        index = i
                    }
                }

                this.invoiceType = invoiceTypeValueList[index]
                this.invoiceTypeName = invoiceTypeNameList [index]
                this.invoiceTypeValueList = invoiceTypeValueList
                this.invoiceTypeNameList = invoiceTypeNameList

                // if(this.common.marketInfo.allowInvoiceType=='3'){
                //     this.invoiceType = Number(this.common.marketInfo.allowInvoiceType)  
                //     this.invoiceTypeName  = '增值税电子专用发票'
                //     this.invoiceTypeValueList=[3] 
                //     this.invoiceTypeNameList =['增值税电子专用发票'] 
      
                // }else if(this.common.marketInfo.allowInvoiceType=='4'){
                //     this.invoiceType = Number(this.common.marketInfo.allowInvoiceType)  
                //     this.invoiceTypeName  = '增值税电子普通发票'
                //     this.invoiceTypeValueList=[4] 
                //     this.invoiceTypeNameList =['增值税电子普通发票'] 
      
                // }else if(this.common.marketInfo.allowInvoiceType=='5'){
                //     this.invoiceType = Number(this.common.marketInfo.allowInvoiceType)  
                //     this.invoiceTypeName  = '增值税电子普通发票(全电）'
                //     this.invoiceTypeValueList=[5] 
                //     this.invoiceTypeNameList =['增值税电子普通发票(全电）'] 
                // }else if(this.common.marketInfo.allowInvoiceType=='6'){
                //     this.invoiceType = Number(this.common.marketInfo.allowInvoiceType)  
                //     this.invoiceTypeName  = '增值税电子专用发票(全电）'
                //     this.invoiceTypeValueList=[6] 
                //     this.invoiceTypeNameList =['增值税电子专用发票(全电）']     
                // }

            }
            console.log( 'this.invoiceType' + this.invoiceType)
            console.log( 'this.invoiceTypeName' + this.invoiceTypeName)

            this.orderNoList=query.orderNoList;
            this.allAmount =query.allAmount;
            // this.LmarketId = param.marketId;
            // 1：会议室，2：物业报修；3：在线账单；4：个人月租；5：临停缴费

            if(this.viewType ==1){
                this.title ="会议室服务费";
            }else if(this.viewType==2){
                this.title ="物业报修服务费";

            }else if(this.viewType==3){
                this.title ="租赁账单";

            }else  if(this.viewType ==4){
                this.title ="月租车服务费";

            }else  if(this.viewType ==5) {
                this.title = "临停车服务费";
            }


           this.invoiceTypeList = [{
                  flex: 1,
                  values: this.invoiceTypeNameList,
                  className: 'slot1',
                  textAlign: 'center'
                }]

            this.getReceiptList();
           // this.resultList =[{"enterpriseName":"万翼科技有限公司上海分公司","enterpriseId":"2cd61841-b12d-44a2-b101-8662a5bc5547","startDate":"2018-07-13","operName":"胡跃明","regNo":"310112001864325","creditNo":"91310112MA1GC3JLX7"},{"enterpriseName":"万翼科技有限公司深圳分公司","enterpriseId":"334e23ce-0e20-41ec-aa96-740def8f7b43","startDate":"2017-06-16","operName":"谢志方","regNo":"91440300MA5EKKQR9Y","creditNo":"91440300MA5EKKQR9Y"},{"enterpriseName":"万翼科技有限公司","enterpriseId":"bf260382-0bcf-46cc-b200-07c7fb9b2e27","startDate":"2016-12-28","operName":"谢志方","regNo":"91440400MA4W4ADC3E","creditNo":"91440400MA4W4ADC3E"}];
        },

        methods: {
              // 获取最新一条数据的发票信息
                getReceiptList(){
                    let params = {
                    pageNo:1,
                    pageSize:2
                    }
                   getReceiptList(params).then(res => {
                        console.log(res)
                        if (res.res.code == '10000') {
                            let data = res.body.receiptList;
                            if(data.length>0){
                                let invoiceDate = data[0];
                                if(invoiceDate.receiptType == '1'){
                                    this.isShowTax =false;
                                    this.riseString = invoiceDate.receiptTitle;
                                    this.emailString = invoiceDate.sendeeEmail;
                                }else{
                                    this.isShowTax =true;
                                    this.riseString = invoiceDate.receiptTitle;
                                    this.emailString = invoiceDate.sendeeEmail;
                                    this.taxString = invoiceDate.ratepayingNumber;
                                }
                            }
                        } else {
                            // util.showToast(res.res.msg)
                        }
                    })
                },
            isEmail(str){
                var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
                    ///^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
                return reg.test(str);
            },
            selectiszengzhi(b){
                this.iszengzhi =b;
               // this.taxString="";
                // var textField = this.$refs.textField;
                // textField.blur();
            },
            selectisShowTax(b){
                this.isShowTax =b;
                this.taxString="";
                // var textField = this.$refs.textField;
                // textField.blur();
            },

            selectmarket(){
                this.popupVisible = true;
                // this.selectType = "selectmarket"
                this.isBottomShow = false;
                this.dataList = this.invoiceTypeList
            },
            onValuesChange(picker, values) {
                if (values[0] > values[1]) {
                    picker.setSlotValue(1, values[0]);
                }
            },
             handleConfirm() {
                this.popupVisible = false
                let value = this.$refs.picker.getValues()[0];
                 for(var i=0;i<this.invoiceTypeNameList.length;i++){
                     if(value == this.invoiceTypeNameList[i]){
                         this.invoiceTypeName =value;
                         this.invoiceType = this.invoiceTypeValueList[i];
                         console.log("this.invoiceType === " + this.invoiceType);
                     }
                 }
             },


            isChn: function(str) {
                 var reg = /^[\u4E00-\u9FA5]+$/;
                 if (!reg.test(str)) {
                     return false;
                 } else {

                     return true;
                 }
             },

            specifiName(e) {
                var val = e.target.value;
                console.log(val);
                let self = this;
                if(this.isShowTax &&val.length>3 &&this.isChn(val)){
                    console.log("oninput searchVal === " +self.riseString);

                    let params = {
                        companyName: self.riseString,
                        //1001 只返回有合同的客商
                    }
                    ReceiptApiSearchByName(params).then(ret => {

                        if(ret.res.code=='10000' ) {
                            if(ret.body!=undefined && ret.body!=null) {
                                self.resultList = ret.body;
                                console.log("ret.body === " + JSON.stringify(self.resultList));
                            }
                        }else {
                          //  self.resultList =[];
                        }

                    })
                }

                if(self.riseString.length>20){
                   self.isRiseTooLong =true;
                }else{
                    self.isRiseTooLong =false;
                }


            },

            onfocus : function (event) {
                let self = this;
                self.isShowClosesearch=true;
                if (this.isShowTax) {
                    this.resultList=[];
                    this.isShowTaxView = true;
                }

            },

            onblur : function (event){
                let self = this;
                self.isShowClosesearch=false;
                //console.log('onfocus ===== ', event.data);
                this.isShowTaxView=false;

            },

            clearsesearch(type){
                let self = this;
                console.log("in clearsesearch")
                if(type==0){
                    self.riseString="";

                }else if(type ==1){
                    self.taxString="";

                }else  if(type ==2){
                    self.emailString="";

                }
            },
            onfocusTax : function (event) {
                let self = this;
                self.isShowClosetax =true;

            },
            onblurTax : function (event){
                let self = this;
                self.isShowClosetax =false;
            },


            onfocusEmail : function (event) {
                let self = this;
                self.isShowCloseemail =true;
            },

            onblurEmail : function (event){
                let self = this;
                self.isShowCloseemail =false;
            },


            isToolong: function(){
              if(this.riseString.length>20){
                    return true;
                }
               return false;
            },

            clickvalidate(){
                if(this.riseString == undefined || this.riseString.length == 0  ||this.riseString==null){
                    console.log("请输入发票抬头")
                    util.showToast("请输入发票抬头")
                    return ;
                }

                if(this.isShowTax) {
                    if (this.taxString == undefined || this.taxString.length == 0 || this.taxString == null) {
                        console.log("纳税人识别号必须为15、18、20位")
                        util.showToast("纳税人识别号必须为15、18、20位")
                        return ;
                    }

                    if(this.taxString.length !=15 && this.taxString.length!=18 && this.taxString.length !=20  ){
                        util.showToast("纳税人识别号必须为15、18、20位")
                        console.log("纳税人识别号必须为15、18、20位")
                        return ;
                    }
                }
                if(this.isEmail(this.emailString)==false){
                    util.showToast("请输入合法的电子邮箱")
                    console.log("请输入合法的电子邮箱")
                    return
                }
            },

            validateparam:function() {
                if (this.riseString == undefined || this.riseString.length == 0 || this.riseString == null) {
                    return false;
                }
                if (this.isShowTax){

                    if (this.taxString == undefined || this.taxString.length == 0 || this.taxString == null) {
                        return false;
                    }
                }
                // if(this.taxString.length !=15 && this.taxString.length!=18 && this.taxString.length !=20  ){
                //
                //     return false;
                // }

                if (this.emailString == undefined || this.emailString.length == 0 || this.emailString == null) {
                        return false;
                }
                if(this.invoiceType ==3 ||this.invoiceType ==6){
                    if (this.bankName == undefined || this.bankName.length == 0 || this.bankName == null) {
                        return false;
                    }
                    if (this.bankNumber == undefined || this.bankNumber.length == 0 || this.bankNumber == null) {
                        return false;
                    }
                     if (this.companyTel == undefined || this.companyTel.length == 0 || this.companyTel == null) {
                        return false;
                    }
                     if (this.companyAddress == undefined || this.companyAddress.length == 0 || this.companyAddress == null) {
                        return false;
                    }
                }

                return true;
            },


            buttonAction(){
                if(this.invoiceType==3 ||this.invoiceType ==6){
                    if(this.bankName){
                         this.bankName = this.bankName.replace(/\s+/g,""); //删除空格换行
                         this.bankName = this.bankName.replace(/\r\n/g,"")
                         this.bankName = this.bankName.replace(/\n/g,"");
                    }
                    if(this.bankName == undefined || this.bankName.length == 0  ||this.bankName==null){
                        console.log("请输入开户银行")
                        util.showToast("请输入开户银行")
                        return
                    }
                    if(this.bankNumber){
                         this.bankNumber = this.bankNumber.replace(/\s+/g,""); //删除空格换行
                         this.bankNumber = this.bankNumber.replace(/\r\n/g,"")
                         this.bankNumber = this.bankNumber.replace(/\n/g,"");
                    }
                    if(this.bankNumber == undefined || this.bankNumber.length == 0  ||this.bankNumber==null){
                        console.log("请输入银行账号")
                        util.showToast("请输入银行账号")
                        return
                    }
                    if(this.companyTel){
                         this.companyTel = this.companyTel.replace(/\s+/g,""); //删除空格换行
                         this.companyTel = this.companyTel.replace(/\r\n/g,"")
                         this.companyTel = this.companyTel.replace(/\n/g,"");
                    }
                    if(this.companyTel == undefined || this.companyTel.length == 0  ||this.companyTel==null){
                        console.log("请输入联系电话")
                        util.showToast("请输入联系电话")
                        return
                    }
                    if(this.companyAddress){
                         this.companyAddress = this.companyAddress.replace(/\s+/g,""); //删除空格换行
                         this.companyAddress = this.companyAddress.replace(/\r\n/g,"")
                         this.companyAddress = this.companyAddress.replace(/\n/g,"");
                    }
                    if(this.companyAddress == undefined || this.companyAddress.length == 0  ||this.companyAddress==null){
                        console.log("请输入开票地址")
                        util.showToast("请输入开票地址")
                        return
                    }

                }

                if(this.riseString){
                    this.riseString = this.riseString.replace(/\s+/g,""); //删除空格换行
                    this.riseString = this.riseString.replace(/\r\n/g,"")
                    this.riseString = this.riseString.replace(/\n/g,"");
                }
                if(this.riseString == undefined || this.riseString.length == 0  ||this.riseString==null){
                    console.log("请输入发票抬头")
                    util.showToast("请输入发票抬头")
                    return
                }


                if(this.isShowTax) {
                    if(this.taxString){
                        this.taxString = this.taxString.replace(/\s+/g,""); //删除空格换行
                        this.taxString = this.taxString.replace(/\r\n/g,"")
                        this.taxString = this.taxString.replace(/\n/g,"");
                    }
                    if (this.taxString == undefined || this.taxString.length == 0 || this.taxString == null) {
                       // toast.showMessage("纳税人识别号必须为15、18、20位");
                       console.log("纳税人识别号必须为15、18、20位")
                       util.showToast("纳税人识别号必须为15、18、20位")
                       return
                    }
                    if(this.taxString.length !=15 && this.taxString.length!=18 && this.taxString.length !=20  ){
                       console.log("纳税人识别号必须为15、18、20位")
                       util.showToast("纳税人识别号必须为15、18、20位")
                       return
                    }
                }

                if(this.emailString){
                    this.emailString = this.emailString.replace(/\s+/g,""); //删除空格换行
                    this.emailString = this.emailString.replace(/\r\n/g,"")
                    this.emailString = this.emailString.replace(/\n/g,"");
                }

                if(this.isEmail(this.emailString)==false){
                    // toast.showMessage("请输入合法的电子邮箱");
                    util.showToast("请输入合法的电子邮箱位")
                    console.log("请输入合法的电子邮箱位")
                    return
                }
                this.isBottomShow =true;
                if(this.$refs.textField){
                    this.$refs.textField.blur();
                }
                 if(this.$refs.textField1){
                    this.$refs.textField1.blur();
                }
                if(this.$refs.textField2){
                    this.$refs.textField2.blur();
                }
                if(this.$refs.textField21){
                    this.$refs.textField21.blur();
                }
                 if(this.$refs.textField22){
                    this.$refs.textField22.blur();
                }
                 if(this.$refs.textField23){
                    this.$refs.textField23.blur();
                }
                 if(this.$refs.textField24){
                    this.$refs.textField24.blur();
                }


            },

            popupOverlayBottomClick () {
                this.isBottomShow = false;
            },


            postData(){

                var self= this;

                if(self.validateparam==false){
                    return;
                }
                var receiptType="1";

                if(this.isShowTax){
                    receiptType="2";
                }

                let params = {
                    'marketId': this.LmarketId,
                    'userId':  this.common.userId,
                    "orderNoList": this.orderNoList,
                    "receiptType":receiptType,
                    "receiptTitle":this.riseString,
                    "ratepayingNumber":this.taxString,
                    "receiptContent":this.title,
                    "receiptAmount":this.allAmount,
                    "sendeeEmail":this.emailString,
                    "orderType":Number(this.viewType),
                    invoiceType:this.invoiceType
                }
                if(this.invoiceType==3 || this.invoiceType==6){
                    params.bankName =this.bankName
                    params.bankNumber =this.bankNumber
                    params.companyTel =this.companyTel
                    params.companyAddress =this.companyAddress
                }
                console.log(JSON.stringify(params));
                util.showLoading("正在提交开票数据…")
                this.popupOverlayBottomClick ()
                InvoicingaddReceipt(params).then(res => {
                    util.hideLoading();
                    console.log(JSON.stringify(res));
                    if(res.res.code=='10000' ){
                        this.gotoSuccess();

                        // const bStack = new BroadcastChannel('InvoicingaddReceipt');
                        // bStack.postMessage(ret);
                    }else {
                        var msg =res.res.msg;
                        if(msg!=null &&msg.length>0){
                            util.showToast(msg)
                        }

                    }
                })

            },

            gotoSuccess(){
                 storage.setS("InvoicSuccess",'InvoicSuccess')
                 this.$router.go(-1)
            },


            closeList(){

                //this.isShowTaxView=false;
                this.resultList =[];
            },
            cellselect(index){
                var v= this.resultList[index];
                this.riseString=v.enterpriseName;
                    //"万翼科技";
                this.taxString =v.creditNo;
                    //"123456789012345";
                // var textField = this.$refs.textField;
                // textField.blur();
                this.resultList =[];
            }


        }


    }
</script>

<style scoped>

    .wrapper {
        background-color: #FFF;
    }
    .scroller {
        flex: 1;
        margin-bottom:108rpx;
    }
    .marginBottom{
        margin-bottom:176rpx;
    }
    .body{
        width: 750px;
        flex-direction: column;
    }

    .top_div{
        height: 232px;
        display: flex;
        flex-direction: column;
    }

    .top_text{
        margin-top: 8px;
        margin-left: 42px;
        color: #333333;
        font-size: 48px;
        text-align: left;
        line-height: 64px;
        height: 66px;

    }

    .top_text1{
        margin-top: 14px;
        margin-left: 42px;
        color: #999999;
        font-size: 24px;
        text-align: left;
        line-height: 34px;
        height: 68px;
        lines:2;

    }


    .top_text2{
        margin-top: 14px;
        margin-left: 42px;
        color: red;
        font-size: 24px;
        text-align: left;
        line-height: 34px;
        height: 34px;
        lines:2;

    }

    .selction_div{
        height: 68px;
        display: flex;
        background-color:#F4F4F4;
    }

    .selction_text{
        margin-top: 16px;
        margin-left: 42px;
        color: #999999;
        font-size: 26px;
        text-align: left;
        line-height: 34px;
        height: 36px;
    }


    .cell_div{
        height: 88px;
        width: 750px;
        display: flex;
        flex-direction: row;
    }


    .cell_title1{
        display: flex;
        margin-top: 24px;
        margin-left: 38px;
        height: 40px;
        width: 118px;
        line-height: 38px;

        color: #333333;
        font-size: 28px;
        text-align: left;
    }

    .cell_iconDiv1{
        width: 36px;
        height: 36px;
        border-radius:18px;
        background-color: #ffffff;
        border-width: 2px;
        border-color:#dadada;
        border-style: solid;
        margin-left: 60px;
        margin-top: 24px;

    }


    .cell_left_iconimage{
        width: 36px;
        height: 36px;
        margin-left: 60px;
        margin-top: 24px;

    }


    .cell_title2{
        margin-top: 24px;
        margin-left: 8px;
        height: 40px;
        line-height: 38px;

        color: #333333;
        font-size: 28px;
        text-align: left;
    }

    .cell_title3{
        margin-top: 24px;
        margin-left: 8px;
        height: 40px;
        line-height: 38px;

        color: #333333;
        font-size: 28px;
        text-align: left;
    }

    .cell_iconDiv2{
        width: 36px;
        height: 36px;
        border-radius:18px;
        background-color: #ffffff;
        border-width: 2px;
        border-color:#dadada;
        border-style: solid;
        margin-left: 40px;
        margin-top: 24px;

    }

    .cell_right_iconimage{
        width: 36px;
        height: 36px;
        margin-left: 40px;
        margin-top: 24px;

    }


    .cellItem_inp{

         flex: 1;
         font-family: "PingFang-SC-Medium";
         font-size: 28px;
         color:#333333;
         text-align: left;
         /*line-height: 30px;*/
         width: 330px;
         height: 88px;
         margin-left: 60px;

     }


    .cellItem_inp1{

        flex: 1;
        font-family: "PingFang-SC-Medium";
        font-size: 20px;
        color:#333333;
        text-align: left;
        /*line-height: 30px;*/
        width: 330px;
        height: 88px;
        margin-left: 60px;

    }


    .Edit_line{
        height: 2px;
        flex-direction: row;
        width: 700px;
        display: flex;
    }

    .Edit_lineleft{
        width: 205px;
        display: flex;
    }

    .Edit_lineright{
        width: 495px;
        display: flex;
        background-color:#F3F4F6;
        border-bottom-width: 1px;
        border-bottom-color: #f0f0f0;
        border-bottom-style: solid;
    }


    .cell_title_type{
        margin-left: 60px;
        margin-top: 24px;
        height: 40px;
        line-height: 38px;

        color: #333333;
        font-size: 28px;
        text-align: left;

    }

    .cell_title_price{
        margin-left: 60px;
        margin-top: 24px;
        height: 40px;
        line-height: 38px;

        color: #0087FF;
        font-size: 28px;
        text-align: left;
        font-weight:bold;


    }


    .button_view{
        width: 750px;
        height: 108px;
        position:fixed;
        bottom: 0px ;
        /*margin-top: 40px;*/
        padding-left: 28px;
        padding-top: 16px;
        padding-right: 28px;
        background-color:#ffffff;
    }


    .button_view1{
        width: 750px;
        height: 108px;
        padding-left: 28px;
        padding-top: 16px;
        padding-right: 28px;
        background-color:#ffffff;
    }

    .button_BG{
        background-color:#DADADA;
        border-radius:8px;
        height:76px;

        box-shadow:0px 2px 8px 0px rgba(0,0,0,0.05);

    }


    .button_BG1{
        background-color:#0087ff;
        border-radius:8px;
        height:76px;
        width: 694px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items:center;

        box-shadow:0px 2px 8px 0px rgba(0,0,0,0.05);

    }

    .button_text{
        margin-top: 16px;
        margin-bottom: 10px;
        font-size: 32px;
        height: 34px;
        color:#ffffff;
        text-align:center;

    }
    .button_text1{
        flex: 1;
        font-family: "PingFang-SC-Medium";
        margin-top: 16px;
        margin-bottom: 10px;
        font-size: 32px;
        height: 34px;
        color:#FFFFFF;
        text-align:center;

    }


    .popup_bg_div{
        flex-direction: column;
        height: 660px;
        display: flex;
    }
    .popup_top_div{
        width: 750px;
        height: 88px;
        display: flex;
        flex-direction: row;

    }


    .popup_top_title{
        margin-top: 22px;
        line-height: 42px;
        font-size: 32px;
        height: 44px;
        width: 618px;
        color:#333333;
        text-align:center;

    }

    .popup_top_leftdiv{
        width: 66px;
        height: 88px;
        display: flex;
    }
    .popup_top_iconimage{
        margin-top: 22px;
        margin-left: 0px;
        height: 44px;
        width: 44px;
    }


    .popup_cell_div{
        width: 750px;
        height: 80px;
        flex-direction: row;

    }

    .popu_cell_left_text{

        /*margin-top: 26px;*/
        margin-left: 40px;
        /*height: 40px;*/
        width: 118px;
        line-height: 38px;

        color: #999999;
        font-size: 28px;
        text-align: left;


    }


    .popu_cell_right_text{

        /*margin-top: 26px;*/
        margin-left: 60px;
        /*height: 40px;*/

        width: 530px;
        line-height: 38px;
        color: #333333;
        font-size: 28px;
        text-align: left;
        lines:2;


    }

    .popup_cell_message_div{
        height: 112px;
    }
    .popup_cell_message_text{
        margin-left: 40px;
        margin-right: 40px;
        margin-top: 18px;
        display: flex;
        width: 670px;
        height: 70px;
        line-height: 34px;

        color: #999999;
        font-size: 24px;
        text-align: left;


    }

    .Edit_list_div{
        height: 415px;
        display: flex;
        flex-direction:column;
        width: 750px;
        border-bottom-color: #EAEAEA ;
        border-bottom-width: 2px;
        border-bottom-style: solid;
    }


    .Edit_list{
        margin-left: 205px;
         display: flex;
        /* background-color: red; */
        flex-direction:column;
        width: 545px;
        height: 330px;
    }


    .Edit_list_cell_div{
        height: 108px;
        display: flex;
        flex-direction: column;
        background-color:#ffffff;

    }

    .Edit_list_cell_titel1{
        margin-left: 5px;
        margin-top: 14px;


        height: 40px;
        line-height: 38px;

        color: #333333;
        font-size: 28px;
        text-align: left;
        width: 520px;


    }

    .Edit_list_cell_titel2{
        margin-left: 5px;
        margin-top: 4px;


        height: 34px;
        line-height: 34px;

        color: #999999;
        font-size: 24px;
        text-align: left;
        width: 520px;


    }

    .Edit_list_cell_line{
        margin-top: 14px;
        margin-left: 5px;
        width: 520px;
        height: 2px;
        background-color:#EAEAEA ;
    }


    .Edit_list_buttonView{
        height: 76px;
        margin-left: 200px;
        width: 500px;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
    }

    .Edit_list_buttonView_title{
        margin-top: 24px;
        height: 40px;
        color: #0087FF;
        font-size: 28px;
        line-height:38px;
        text-align: left;
    }


    .closeIcon_div{
        width: 50px;
        flex-direction: row;
        justify-items: center;
        align-items: center;
        justify-content: center;

    }

    .closeIcon_iconbg{
        width: 28px;
        height: 28px;

        background-color: #999999;
        border-radius: 100%;


    }

    .closeIcon_iconX{
        margin-top: -2px;
        font-size: 28px;
        line-height: 28px;
        color: #ffffff;
        text-align: center;
    }


    .closeIcon_iconimage{
        width: 30px;
        height: 30px;

    }
    .popupBg{
         position: fixed;
         background: white;
        bottom:0;left:0;right:0;
        z-index:9999;
        display: flex;
        height:660px;
        width:100%;
        border-top-width: 2px;
        border-top-color: #DADADA;
        border-top-style: solid;
    }
    .footer {
        position: fixed;
        bottom:0;left:0;right:0;
        z-index:333;
        background:#fff;
        height:108px;
        width:100%;


    }
     .pdiv{
            display: block;
            margin:16px 28px;
            height:76px;
            line-height:76px;
            text-align:center;
            background:#dadada;
            border-radius: 4px;
            color:#fff;
            font-size:32px;
        }

    .canclick{
                background:#0087ff;
            }


</style>
